import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslations from './locales/en.json';
import esTranslations from './locales/es.json';
import frTranslations from './locales/fr.json';
import deTranslations from './locales/de.json';

const resources = {
  en: {
    translation: enTranslations,
  },
  es: {
    translation: esTranslations,
  },
  fr: {
    translation: frTranslations,
  },
  de: {
    translation: deTranslations,
  },
};

const PREFERRED_LANGUAGE_KEY = 'preferred-language';
const DEFAULT_LANGUAGE = 'en';

const getStoredLanguage = () => {
  if (typeof window === 'undefined') {
    return null;
  }

  try {
    return localStorage.getItem(PREFERRED_LANGUAGE_KEY);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn(
      'Unable to access localStorage for language preference.',
      error
    );
    return null;
  }
};

const storeLanguage = (language: string) => {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    localStorage.setItem(PREFERRED_LANGUAGE_KEY, language);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn('Unable to persist language preference.', error);
  }
};

const initialLanguage = getStoredLanguage() || DEFAULT_LANGUAGE;

i18n.use(initReactI18next).init({
  resources,
  lng: initialLanguage,
  fallbackLng: DEFAULT_LANGUAGE,
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: false,
  },
});

i18n.on('languageChanged', storeLanguage);

export default i18n;
